import React from "react";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import PaymentHeader from "./PaymentHeader"; // Assuming you already have this component
import { CustomButton } from "../../globalStyle";
import routeConstant from "../../utils/routeConstant";
import { SuccessPaymentIcon } from "../../assets/Icons";

const PaymentMethodUpdateSuccess = () => {
  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        flexDirection: "column",
        alignItems: "center",
        gap: "170px",
        backgroundColor: "#FFF",
      }}
    >
      <PaymentHeader />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "40px",
        }}
      >
        <SuccessPaymentIcon />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <Typography
            style={{
              fontWeight: 700,
              fontSize: "32px",
              lineHeight: "39px",
              color: "#414042",
              textAlign: "center",
            }}
          >
            Payment Method Added Successfully!
          </Typography>
          <Typography
            style={{
              fontWeight: 500,
              fontSize: "20px",
              lineHeight: "30px",
              textAlign: "center",
              color: "#58595B",
            }}
          >
            Your payment method has been successfully added. You can now proceed
            with your next transaction.
          </Typography>
          <Link to={routeConstant?.paymentMethods}>
            <CustomButton
              style={{
                marginTop: "40px",
                fontSize: "16px",
                color: "white",
                borderRadius: "25px",
                background:
                  "linear-gradient(94.04deg, #1c75bc 2.44%, #00aeef 112.73%)",
                padding: "10px 30px",
                height: "38px",
              }}
            >
              Go to Payment Methods
            </CustomButton>
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default PaymentMethodUpdateSuccess;
